module.exports = __webpack_public_path__ + "static/media/newLogoICAmp.07940916.png";